<template>
  <div class="columns is-desktop">
    <div class="column">
      <config-person-id-general-properties/>
    </div>
    <div class="column is-one-quarter">
      <config-person-id-identifier-summary style="margin-bottom: 1rem"/>
      <quick-tips-person-id-configuration/>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import ConfigPersonIdGeneralProperties from '@/components/ConfigPersonIdGeneralProperties.vue';
import ConfigPersonIdIdentifierSummary from '@/components/ConfigPersonIdIdentifierSummary.vue';
import QuickTipsPersonIdConfiguration from '@/components/QuickTipsPersonIdConfiguration.vue';

library.add(
  faEdit,
);
export default {
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
    ConfigPersonIdGeneralProperties,
    ConfigPersonIdIdentifierSummary,
    QuickTipsPersonIdConfiguration,
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
</style>
